export default __webpack_public_path__ + "static/media/calendar-icon.1f277523.svg";